import { memo } from 'react'
import { Controls, MiniMap, ControlButton } from '@xyflow/react'
import { cn } from '@trafiflow/shared-ui'
import { LayoutGrid, Maximize2 } from 'lucide-react'

interface PipelineControlsProps {
  onFitView?: () => void
  onToggleLayout?: () => void
  className?: string
}

function PipelineControlsComponent({
  onFitView,
  onToggleLayout,
  className,
}: PipelineControlsProps) {
  return (
    <>
      <Controls
        className={cn(
          '[&>button]:!bg-tf-bg-card [&>button]:!border-tf-border [&>button]:!text-tf-text',
          '[&>button:hover]:!bg-tf-bg-muted',
          className,
        )}
        showFitView={false}
        showZoom
        showInteractive={false}
      >
        {onFitView && (
          <ControlButton onClick={onFitView} title="Fit to view">
            <Maximize2 className="w-3.5 h-3.5" />
          </ControlButton>
        )}
        {onToggleLayout && (
          <ControlButton onClick={onToggleLayout} title="Toggle layout">
            <LayoutGrid className="w-3.5 h-3.5" />
          </ControlButton>
        )}
      </Controls>

      <MiniMap
        className={cn(
          '!bg-tf-bg-card !border !border-tf-border !rounded-lg',
          '[&_.react-flow__minimap-mask]:!fill-tf-bg/80',
        )}
        nodeColor={(node) => {
          const data = node.data as { stage?: { status?: string } } | undefined
          const status = data?.stage?.status
          switch (status) {
            case 'completed':
              return 'rgb(16, 185, 129)' // emerald-500
            case 'running':
              return 'rgb(59, 130, 246)' // blue-500
            case 'failed':
              return 'rgb(239, 68, 68)' // red-500
            case 'degraded':
              return 'rgb(245, 158, 11)' // amber-500
            default:
              return 'rgb(107, 114, 128)' // gray-500
          }
        }}
        maskColor="rgba(0, 0, 0, 0.5)"
        pannable
        zoomable
      />
    </>
  )
}

export default memo(PipelineControlsComponent)
